module.exports = __webpack_public_path__ + "media/images/emoticons/sports-187819f344b3829d19eca47e7fbb3655.gif";